import React, { useEffect, useRef } from "react";
import { SessionDetailViewer, ActiveSessionsProvider, ActiveSessionsTable } from "pages/dashboard/components/active_sessions";
import FleetDropdownFilter from "pages/dashboard/components/FleetDropdownFilter";
import { Alert, Spinner, Row, Col } from "react-bootstrap";
import Search from "pages/dashboard/components/Search";
import { useSuperState } from "helpers/hooks";
import { useApp } from "common/context";

const ActiveSessions = props => {

    const [state, setState] = useSuperState({
        error: null,
        loading: true,
        sessions: [],
        search: '',
        appstream_fleet_name: null
    });

    const { api } = useApp();
    const session_detail_ref = useRef();

    const { error, loading, sessions, appstream_fleet_name, search } = state;

    const clearError = () => setState({ error: null });

    const refreshSessions = async () => {

        try {

            const { sessions } = await api.get("/api/appstream/sessions/all", { appstream_fleet_name, search });
            setState({ sessions });

        } catch (e){

            const error = e?.err || e?.message || e;
            setState({ error });

        }

    };

    const handleViewDetails = session => {

        const modal = session_detail_ref?.current;
        if (!modal) return;

        modal.show(session);

    };

    const handleExpireSession = async appstream_user_id => {

        if (!window.confirm('Are you sure you want to expire this session?')) return;

        try {

            setState({ loading: true });

            await api.post("/api/appstream/expire-session", { appstream_user_id });
            await refreshSessions();

            setState({ loading: false });

        } catch (e){

            const error = e?.err || e?.message || e;
            setState({
                error,
                loading: false
            });

        }

    };

    useEffect(() => {

        let interval;

        setState({
            loading: true
        });

        (async() => {

            await refreshSessions();

            setState({ loading: false });

            interval = setInterval(refreshSessions, 10000);

        })();

        return () => {

            clearInterval(interval);

        };

    }, [appstream_fleet_name, search]);

    const context = {
        sessions,
        appstream_fleet_name,
        handleViewDetails,
        handleExpireSession
    };

    return (
        <ActiveSessionsProvider value={context}>

            {error && (
                <Alert variant="danger" dismissible onClose={clearError}>
                    {error}
                </Alert>
            )}

            {loading ?
                (
                    <div className="text-center">
                        <Spinner animation="border" role="status">
                            <span className="visually-hidden">
                                Loading...
                            </span>
                        </Spinner>
                    </div>
                )
                :
                (

                    <>
                        <Row>
                            <Col md={6} lg={3} className="mb-sm-2 mb-md-0 mb-2">
                                <Search onChange={val => setState({ search: val })} defaultValue={search} />
                            </Col>

                            <Col md={6} lg={3}>
                                <FleetDropdownFilter
                                    onChange={appstream_fleet_name => setState({ appstream_fleet_name })}
                                    value={appstream_fleet_name}
                                />
                            </Col>
                        </Row>

                        <hr/>

                        <ActiveSessionsTable />
                    </>

                )
            }

            <SessionDetailViewer ref={session_detail_ref}/>

        </ActiveSessionsProvider>
    );
};

export default ActiveSessions;
